export const formatProductsForGoogleAnalytics = (products) => {
  return products.map(product => {
    let data = {
      id: product.get('product_id'),
      name: product.get('product_name'),
      quantity: product.getIn(['cart', 'qty']),
      price: product.getIn(['cart', 'price']),
    };

    if (product.getIn(['sub_category', 'category', 'product_category_name']) != '') {
      let category = product.getIn(['sub_category', 'category', 'product_category_name']);
      if (product.getIn(['sub_category', 'product_sub_category_name']) != '') {
        category += '/' + product.getIn(['sub_category', 'product_sub_category_name']);
      }

      data.category = category;
    }

    return data;
  }).toJS();
};